import { render } from "./Breeders.vue?vue&type=template&id=307ef27e&scoped=true"
import script from "./Breeders.vue?vue&type=script&lang=js"
export * from "./Breeders.vue?vue&type=script&lang=js"

import "./Breeders.vue?vue&type=style&index=0&id=307ef27e&scoped=true&lang=css"

import exportComponent from "/Users/chordarts/pasti/dev10/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-307ef27e"]])

export default __exports__